'use strict';

import React from 'react';

class SearchSuggestions extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        let suggestionsClassName = 'suggestive-search-suggestions-container' + (this.props.showSuggestions === true ? ' d-block' : ' d-none');

        return (
            <div className={suggestionsClassName}>
                <nav>
                    <ul className="suggestive-search-suggestions-list">
                        {this.props.suggestions.map(suggestion => (
                            <li className='suggestive-search-suggestions-list-li'>
                                <a href={suggestion.AbsoluteLink} className='suggestive-search-suggestions-list-link'>
                                    <h5>{suggestion.Title}</h5>
                                    <p>{suggestion.MetaDescription ? suggestion.MetaDescription : suggestion.Summary }</p>
                                    <span className='fa fa-link suggestive-search-suggestions-list-icon' />
                                </a>
                            </li>
                        ))}
                    </ul>
                </nav>
            </div>
        );
    }
}

export default SearchSuggestions;
